/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendWorkingCapitalParameterDto } from '../../models/backend-working-capital-parameter-dto';

export interface FinancingSourcesWorkingCapitalParametersList$Params {
  create_date?: string;
  is_blocked?: boolean;
  percentage_immediate_pay_sales?: number;
  project?: number;
  share_advance_purchase_general?: number;
  share_advance_sales_general?: number;
  share_cash_sales_general?: number;
  share_deferred_sales_general?: number;
  share_different_purchase_general?: number;
  share_purchases_with_immediate_payment?: number;
  turnover_advance_purchase_general?: number;
  turnover_advance_sales_general?: number;
  turnover_deferred_sales_general?: number;
  turnover_different_purchase_general?: number;
  turnover_inventory_general?: number;
  turnover_vat_general?: number;
  variant_name?: string;
  wc_end_switch?: boolean;
}

export function financingSourcesWorkingCapitalParametersList(
  http: HttpClient,
  rootUrl: string,
  params?: FinancingSourcesWorkingCapitalParametersList$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<Array<BackendWorkingCapitalParameterDto>>> {
  const rb = new RequestBuilder(rootUrl, financingSourcesWorkingCapitalParametersList.PATH, 'get');
  if (params) {
    rb.query('create_date', params.create_date, {});
    rb.query('is_blocked', params.is_blocked, {});
    rb.query('percentage_immediate_pay_sales', params.percentage_immediate_pay_sales, {});
    rb.query('project', params.project, {});
    rb.query('share_advance_purchase_general', params.share_advance_purchase_general, {});
    rb.query('share_advance_sales_general', params.share_advance_sales_general, {});
    rb.query('share_cash_sales_general', params.share_cash_sales_general, {});
    rb.query('share_deferred_sales_general', params.share_deferred_sales_general, {});
    rb.query('share_different_purchase_general', params.share_different_purchase_general, {});
    rb.query('share_purchases_with_immediate_payment', params.share_purchases_with_immediate_payment, {});
    rb.query('turnover_advance_purchase_general', params.turnover_advance_purchase_general, {});
    rb.query('turnover_advance_sales_general', params.turnover_advance_sales_general, {});
    rb.query('turnover_deferred_sales_general', params.turnover_deferred_sales_general, {});
    rb.query('turnover_different_purchase_general', params.turnover_different_purchase_general, {});
    rb.query('turnover_inventory_general', params.turnover_inventory_general, {});
    rb.query('turnover_vat_general', params.turnover_vat_general, {});
    rb.query('variant_name', params.variant_name, {});
    rb.query('wc_end_switch', params.wc_end_switch, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<Array<BackendWorkingCapitalParameterDto>>;
    }),
  );
}

financingSourcesWorkingCapitalParametersList.PATH = '/api/financing_sources/working_capital_parameters/';
